module.exports = __webpack_public_path__ + "static/img/10019 (1).242b8da.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/10000/10019 (1).webp
// module id = 4JFO
// module chunks = 14